import React from 'react'
import { Navigate, type RouteObject } from 'react-router-dom'
import type { Location } from 'react-router-dom'

import { OLD_QUERIES_PATH, QUERIES_PATH, QUERIES_PERMISSION } from '../components/Queries/queriesModule'

const BukiPage = React.lazy(() => import('../pages/Queries/BukiPage'))

/**
 * One route. Saved queries, Scheduled, Review and "What we've told it" are Phase 3+ and
 * are not registered here — a route that renders nothing is a promise to staff that the
 * screen exists.
 *
 * The guard is the same shape every other section uses (see `donorRoutes.js`), reading the
 * same `VisibleTabs` list. The gate is `AdsBuki`, which is what the endpoint checks.
 */
export const getQueriesRoutes = (
    loggedIn: boolean,
    visibleTabs: string[] | undefined,
    location: Location,
    loginRedirect: string,
): RouteObject[] => [
    {
        path: QUERIES_PATH,
        element:
            loggedIn && visibleTabs?.includes(QUERIES_PERMISSION) ? (
                <BukiPage />
            ) : (
                <Navigate to={loginRedirect} state={{ from: location }} replace />
            ),
    },
    { path: OLD_QUERIES_PATH, element: <Navigate to={QUERIES_PATH} replace /> },
]
